import { Measure } from './measure.model';
import { Line } from "./line.model";

export class Campaign {
  id:         number;
  endDate:    string;
  line:       Line;
  measures:   Measure[];
  modifiedOn: string;
  percentage: number;
  startDate:  string;
  state:      string;

  constructor() {
    this.line = new Line();
  }
}




// WEBPACK FOOTER //
// ./src/app/models/campaign.model.ts